
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.5 0a9.5 9.5 0 110 19 9.5 9.5 0 010-19zm0 1a8.5 8.5 0 100 17 8.5 8.5 0 000-17zM9 4h1v5.423l4.696 2.711-.5.866L9 10V4z","fill":"#000"}})])
          )
        }
      }
    